<template>
  
<v-row class="pa-0">
  <v-col cols="12" md="5" class="d-flex align-center flex-row">
    <v-switch v-model="properties.prelevato" label="Prelevato" color="success" inset class="mr-4"
        @update:modelValue="prelevatoUpdated"
        hide-details />
  </v-col>
  <v-col cols="12" md="7" class="d-flex align-center flex-row"  v-if="properties.prelevato">

    <v-text-field class="flex-grow-1 mr-1" v-model="properties.codice"
        label="Codice prelievo" type="text" :readonly="true" placeholder="ggmmaa-hhmm-ID" hide-details>
      <template v-slot:append>

        <v-btn size=""  color="primary" @click="copy2clipboard(properties.codice)" class="pa-4">
      <v-icon>mdi-content-copy</v-icon>
    </v-btn>
      </template>
    </v-text-field>
  </v-col>
</v-row>
  
<v-row class="pa-0"  v-if="properties.prelevato">
  <v-col cols="12" md="12" class="d-flex align-center flex-row">
    <v-switch v-model="properties.analisi_genetica" label="Analisi genetica" color="success" inset class="mr-4"
        hide-details />
  </v-col>
</v-row>


</template>

<script setup>

import { onMounted } from "vue";
import { useToastsStore } from "@/store/toasts";
import { useCopyToClipboard } from "@/service/copyToClipboard";
import { useRuntimeStore } from '@/store/runtime'
const runtimeStore = useRuntimeStore()

const {copy2clipboard}  = useCopyToClipboard();
const toastsStore = useToastsStore();

const properties = defineModel("properties")
const props = defineProps({
  "timestamp": {
    type: Number,
    required: true
  }
})

onMounted(() => {
})



const generateCodicePrelievo = () => {
  // ggmmaa-hhmm-ID
  const now = new Date(props.timestamp)
  const day = (now.getDate()).toString().padStart(2, '0')
  const month = (now.getMonth() + 1).toString().padStart(2, '0')
  const year = (now.getFullYear()).toString().slice(2, 2)
  const hours = (now.getHours()).toString().padStart(2, '0')
  const minutes = (now.getMinutes()).toString().padStart(2, '0')
  const id = runtimeStore.session.user.pk.toString().padStart(3, '0')
  const codice = `${day}${month}${year}-${hours}${minutes}-${id}`
  return codice
}


const prelevatoUpdated = () => {
  if (properties.value.prelevato === true) {
    properties.value.codice = generateCodicePrelievo()
  }
  else {
    delete properties.value.codice
    properties.value.analisi_genetica = null

  }
}


</script>

<style scoped>
</style>
